export default {"src":"/_next/static/image/public/images/Earn_secure_points.887241c215c433a0889c07ce047bcc25.svg","height":106,"width":181};